<template>
  <div class="morespace">
    <h3>Heroes</h3>
    <h3>
      {{ player.name }} <span>({{ player.level }})</span>
    </h3>
    <h3></h3>
    <div class="flex">
      <div class="spellist">
        <div
          @click="unequip(spell)"
          :key="spell.id"
          v-for="spell in player.spells"
        >
          <Spell :spell="spell" />
        </div>
      </div>
      <div class="spellist">
        <div v-if="player.allspells.length > 0">
          <div
            @click="equip(spell)"
            :key="spell.id"
            v-for="spell in player.allspells"
          >
            <Spell :spell="spell" />
          </div>
        </div>
        <div v-else>Empty</div>
      </div>
    </div>
    <div>
      <h3>
        Attributes
        <span v-if="player.apoints">({{ player.apoints }})</span>
      </h3>

      <div class="enemies">
        <div :key="i" v-for="(attr, i) in player.attr">
          <span> {{ i }}:</span>
          <span> {{ attr }}</span>
          <button @click="addPoint(i)">+</button>
        </div>
      </div>
    </div>
    <div>
      <h3>Points</h3>
      <div class="enemies">
        <div :key="enemy" v-for="(i, enemy) in player.counter">
          <img
            style="width: 30px; float: left"
            :src="getImgUrl(enemy)"
            :alt="enemy"
          />
          <span style="line-height: 30px; font-size: 20px">{{ i }}</span>
        </div>
      </div>
    </div>
    <div>
      <h3>Resistance</h3>
      <div class="spellist">
        <div :key="spell.id" v-for="spell in player.allresistance">
          <Spell :spell="spell" />
        </div>
      </div>
    </div>
    <div>
      <h3>Passives</h3>
      <div class="flex">
        <div class="spellist">
          <div
            @click="unequipP(spell)"
            :key="spell.id"
            v-for="spell in player.passive"
          >
            <Spell :spell="spell" />
          </div>
        </div>
        <div class="spellist">
          <div v-if="player.allspells.length > 0">
            <div
              @click="equipP(spell)"
              :key="spell.id"
              v-for="spell in player.allpassive"
            >
              <Spell :spell="spell" />
            </div>
          </div>
          <div v-else>Empty</div>
        </div>
      </div>
    </div>

    <button @click="resetPlayer">reset</button>
    <button @click="save">save</button>
  </div>
</template>

<script>
import Spell from "@/components/Spell";
import { mapState } from "vuex";

export default {
  name: "Heroes",
  components: {
    Spell,
  },
  computed: {
    ...mapState(["player"]),
  },
  methods: {
    save() {
      this.$store.dispatch("savePlayer");
    },
    resetPlayer() {
      this.$store.dispatch("resetPlayer");
    },
    equip(spell) {
      this.$store.dispatch("equipPlayer", spell);
    },
    equipP(pas) {
      this.player.passive.push(pas);
      let ind = this.player.allpassive.indexOf(pas);
      if (ind >= 0) {
        this.player.allpassive.splice(ind, 1);
      }
    },
    addPoint(a) {
      if (this.player.apoints > 0) {
        this.player.apoints--;
        this.player.attr[a]++;
        this.player.recalculate();
      }
    },
    unequipP(pas) {
      if (pas.id == "conlife") {
        return;
      }
      this.player.allpassive.push(pas);
      let ind = this.player.passive.indexOf(pas);

      if (ind >= 0) {
        this.player.passive.splice(ind, 1);
      }
    },
    unequip(spell) {
      if (spell.id == "basic") {
        return;
      }
      this.player.allspells.push(spell);
      let ind = this.player.spells.indexOf(spell);

      if (ind >= 0) {
        this.player.spells.splice(ind, 1);
      }
    },
    getImgUrl(id) {
      var images = require.context("../assets/img/enemies", false, /\.webp$/);
      return images("./" + id + ".webp");
    },
  },
};
</script>

<style scoped>
.enemies {
  display: flex;
  flex-wrap: wrap;
}

.enemies > * {
  padding: 5px;
  margin: 2px;
  border: 1px solid black;
  background: lightgrey;
}
.enemies img {
  margin-right: 5px;
}
.flex {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.spellist {
  display: flex;
  flex-direction: row;
  text-align: center;
  background: lightslategray;
  border: 1px solid black;
  padding: 10px;
}
.morespace {
  padding-bottom: 500px;
}
</style>